import { Heading, Modal } from '@zillow/constellation-10';

import { useScreenSize } from '../../../hooks';

import type { FC } from 'react';

interface VrModel {
  tourUrl: string;
  name: string;
}

interface ViewTourModalProps {
  vrModel: VrModel;
  onClose: () => void;
}

const ViewTourModal: FC<ViewTourModalProps> = ({ vrModel: { name, tourUrl }, onClose }) => {
  const { isScreenMobile } = useScreenSize();

  let height = '700px';
  // Needed because sphere-viewer doesn't handle properly height 100% or 100vh.
  if (typeof window !== 'undefined' && isScreenMobile) {
    // 72 corresponds to the modal header height + padding
    const innerHeight = window.innerHeight - 72;
    height = `${innerHeight}px`;
  }

  return (
    <Modal
      header={name && <Heading level={3}>{name}</Heading>}
      body={<iframe width="100%" height={height} title={name} src={tourUrl} />}
      open={true}
      onOpenChange={(open) => !open && onClose()}
      size={{ base: 'fullScreen', lg: 'md' }}
    />
  );
};

export type { ViewTourModalProps };
export { ViewTourModal };
export default ViewTourModal;
